<template>
  <Modal
    :title="$t('edit_supplier')"
    modalId="edit-modal"
    @submit="updateSupplier"
  >
    <form @submit.prevent="updateSupplier">
      <div class="mb-3">
        <label class="form-label">{{ $t('supplier_name') }} <span class="">*</span></label>
        <input
          type="text"
          v-model="supplier.name"
          class="form-control"
        />
        <!-- Error for store -->
        <div v-if="errors.name" class="text-danger mt-2">
          <span>{{ errors.name }}</span>
        </div>

        <label class="form-label">{{ $t('supplier_address') }} </label>
        <input
          type="text"
          v-model="supplier.address"
          class="form-control"
        />
        <!-- Error for store -->
        <div v-if="errors.address" class="text-danger mt-2">
          <span>{{ errors.address }}</span>
        </div>

        <label class="form-label">{{ $t('supplier_phone_number') }} </label>
        <input
          type="text"
          v-model="supplier.phone_number"
          class="form-control"
        />
        <!-- Error for store -->
        <div v-if="errors.phone_number" class="text-danger mt-2">
          <span>{{ errors.phone_number }}</span>
        </div>
      </div>
      <!-- General error message -->
      <div v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</div>
    </form>
  </Modal>
</template>

<script>
import Modal from '@/components/common/Modal.vue';
import apiUrls from '../../../urls';
import {useToast} from "vue-toastification";

export default {
  components: {
    Modal,
  },

  props: {
    selectedSupplier: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      supplier: {
        id: null,
        name: '',
        address: '',
        phone_number: '',
      },
      errorMessage: '',  // General error message (if any)
      errors: {},        // For storing individual field errors
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  watch: {
    selectedSupplier: {
      immediate: true,
      handler(newSupplier) {
        if (newSupplier && newSupplier.id) {
          this.supplier = { ...newSupplier }; // Copy selected Supplier data
        }
      },
    },
  },
  methods: {
    async updateSupplier() {
      this.errors = {};  // Reset errors
      this.errorMessage = "";  // Reset general error message

      // Frontend validation
      if (!this.supplier.name.trim()) this.errors.name = "Supplier name is required.";

      // Address is optional, trim it only if it's a string and not null/undefined
      if (this.supplier.address && typeof this.supplier.address === 'string') {
        this.supplier.address = this.supplier.address.trim();
      } else {
        this.supplier.address = '';
      }

      // Phone number is optional but should be valid if entered
      if (this.supplier.phone_number && this.supplier.phone_number.trim()) {
        const phoneRegex = /^[0-9]{10,15}$/;
        if (!phoneRegex.test(this.supplier.phone_number.trim())) {
          this.errors.phone_number = "Enter a valid phone number (10-15 digits).";
        }
      } else {
        this.supplier.phone_number = '';
      }

      if (Object.keys(this.errors).length > 0) return; // Stop if validation fails

      try {
        const response = await this.$axios.patch(
            apiUrls.inventory_supplier.update.replace(':pk', this.supplier.id),
            {
              name: this.supplier.name.trim(),
              address: this.supplier.address.trim() || null,
              phone_number: this.supplier.phone_number.trim() || null,
            }
        );

        this.toast.success('Supplier successfully updated!')

        // Close modal after success
        const modal = document.getElementById('edit-modal');
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) modalInstance.hide();

        // Emit event to update parent component
        this.$emit('edit_success');

        this.resetForm();
      } catch (error) {
         if (error.response?.data?.errors) {
          this.errors = { ...error.response.data.errors };
        } else if (error.response?.data?.error) {
          this.errorMessage = error.response.data.error;
        } else {
          this.errorMessage = "An unexpected error occurred. Please try again.";
        }
      }
    },
    resetForm() {
      this.supplier = { id: null, name: '', address: '', phone_number: '' };
      this.errors = {};
      this.errorMessage = '';
    },
  },
};
</script>
